import { get } from "lodash";
import moment from "moment";
import format from "string-template";
import { DATE_FORMAT } from "utils/constants";
import buildCardBlockHtml from "./buildCardBlockHtml";

const buildEditorBlocks = ({
  emailContent,
  mailTranslations,
  project,
  costs,
  user,
  phoneNumber,
  email,
  address,
  addLinks,
}) => {
  const endOfValidityDate =
    moment().format("MM") === "12"
      ? moment().endOf("M").format(DATE_FORMAT)
      : moment().add(30, "d").format(DATE_FORMAT);

  const upsells = get(project, "fields.upsells", {});

  return {
    blocks: [
      {
        type: "paragraph",
        style: { fontSize: 20 },
        data: {
          text: format(get(emailContent, "HEADER"), {
            gender:
              mailTranslations[get(project, "contact.user.gender", "")],
            firstName: get(project, "contact.user.firstname", ""),
            lastName: get(project, "contact.user.lastname", ""),
          }),
        },
      },
      {
        type: "paragraph",
        data: {
          text: get(emailContent, "P1"),
        },
      },
      {
        type: "paragraph",
        data: {
          text: format(get(emailContent, "P2"), {
            currentDate: moment().format(DATE_FORMAT),
          }),
        },
      },
      {
        type: "paragraph",
        data: {
          text: get(emailContent, "P3"),
        },
      },
      {
        type: "paragraph",
        data: {
          text: format(get(emailContent, "P4"), {
            endOfValidityDate,
          }),
        },
      },
      {
        type: "paragraph",
        data: {
          text: "",
        },
      },
      {
        id: "cardBlock",
        type: "readonly",
        data: {
          text: buildCardBlockHtml({
            costs,
            upsells,
            addLinks,
            buttonLabel: get(emailContent, "SUBSCRIPTION_BUTTON"),
          }),
        },
      },
      {
        type: "paragraph",
        data: {
          text: "",
        },
      },
      {
        type: "paragraph",
        data: {
          text: get(emailContent, "P5"),
        },
      },
      {
        type: "paragraph",
        data: {
          text: format(get(emailContent, "P6"), {
            phoneNumber,
          }),
        },
      },
      {
        type: "paragraph",
        data: {
          text: "",
        },
      },
      {
        type: "paragraph",
        data: {
          text: get(emailContent, "SINCERLY"),
        },
      },
      {
        type: "paragraph",
        data: {
          text: "---",
        },
      },
      {
        type: "paragraph",
        data: {
          text: get(emailContent, "YOUR_ADVISOR"),
        },
      },
      {
        type: "paragraph",
        data: {
          text: `${get(user, "firstname", "")} ${get(user, "lastname", "")}`,
        },
      },
      {
        type: "paragraph",
        data: {
          text: `
            ${mailTranslations.TEL}: ${phoneNumber}
          `,
        },
      },
      {
        type: "paragraph",
        data: {
          text: `
            ${mailTranslations.EMAIL}: ${email}
          `,
        },
      },
      {
        type: "paragraph",
        data: {
          text: `
            ${mailTranslations.ADDRESS}: ${address}
          `,
        },
      },
    ].filter((_) => get(_, "data.text") !== undefined),
  };
};

export default buildEditorBlocks;
